<div class="modal-form">
    <h2 mat-dialog-title class="jumbotron-heading text-center">Edit Loan Scenario</h2>
    <mat-dialog-content class="mat-typography">
        <lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>

        <div class="edit">
            <div class="Vert-10"></div>
            <lus-loan-scenario-form *ngIf="!!scenarioForm" [propertyInfoForm]="scenarioForm"
                [propertyAddress]="propertyAddress"></lus-loan-scenario-form>
        </div>


    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions" align="end">
        <button mat-stroked-button class="btn btn-secondary" (click)="onCancel()">
            Cancel
        </button>
        <button mat-stroked-button class="btn btn-primary" (click)="onConfirmSave()" [disabled]="!scenarioForm.valid">
            Save
        </button>
    </mat-dialog-actions>
</div>